import type { LabelHTMLAttributes } from 'react';

/**
 * Not in @tervior-tech/tervior-shared-ui-react v0.3.0 (only Button/Header/
 * Footer are exported today — Header/Footer are site-specific, see
 * App.tsx's docstring) — built here per the Brutalist label convention
 * (font-mono, uppercase, tracked) already established in App.tsx's
 * "ambiente: staging" chip.
 */
export function Label({ className = '', ...props }: LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={`font-mono text-xs font-medium uppercase tracking-widest text-muted-foreground ${className}`}
      {...props}
    />
  );
}
